var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-navbar__toggle js-navbar-toggle",
    height: 512,
    viewBox: "0 0 16 16",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_31",
    "data-name": 31
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.5 4h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 9h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 14h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.001370e5336f5a1b2f05fac394c55e21.svg";
export { ForwardRef as ReactComponent };